<script>
  import { GlModal } from '@gitlab/ui';
  
  export default {
    name: 'SessionTimeoutDialog',
    components: {
      GlModal,
    },
    data() {
      return {
        showDialog: false,
        dialogTitle: 'Session Timeout',
        dialogMessage: 'Your session has been inactive for 2 minutes and 30 seconds.',
        showCountdown: false,
        countdown: 30,
        countdownInterval: null,
        timeoutId: null,
        targetEndTime: null,
      };
    },
    methods: {
      startDialog() {
        this.showDialog = true;
        this.showCountdown = true;
        
        this.targetEndTime = Date.now() + 30000;
        
        this.countdown = 30; 
        
        clearTimeout(this.timeoutId);
        clearInterval(this.countdownInterval);
        this.startCountdown();
      },
      startCountdown() {
        this.countdownInterval = setInterval(() => {
          const now = Date.now();
          const distance = this.targetEndTime - now;
          const secondsRemaining = Math.ceil(distance / 1000);
  
          this.countdown = secondsRemaining;
  
          if (this.countdown <= 0) {
            this.logout();
          }
        }, 1000);
      },
      resumeSession() {
        this.showDialog = false;
        this.resetCountdown();
        this.$emit('session-resumed');
      },
      logout() {
        this.showDialog = false;
        this.resetCountdown();
        this.$store.dispatch('auth/logout');
      },
      resetCountdown() {
        this.showCountdown = false;
        clearTimeout(this.timeoutId);
        clearInterval(this.countdownInterval);
        this.countdown = 30;
        this.targetEndTime = null;
      },
      onHidden() {
        this.resetCountdown();
      },
    },
  };
  </script>